import { parse } from 'date-fns';

// формат "MM.YYYY"
export function parseWorkStartDate(dateString: string): Date {
  return parse(dateString, 'MM.yyyy', new Date());
}
